<p><span>{{attribute.key}}: </span><br> {{attribute.value}}</p>